export default __webpack_public_path__ + "locales/lo-LA/PaymentsEnterprise.json?hash=edf0d2acc73b7fcb8cf60ff07168adf3";